var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded == true),expression:"loaded == true"}],attrs:{"id":"wallet_container"}}),(_vm.loaded == false)?_c('v-progress-circular',{attrs:{"size":"60","width":"12","color":"primary","indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }